import create from 'utils/createReduxPromiseActionType'

export const ADD = create('comments/ADD')
export const LOAD = create('comments/LOAD')
